import React, { useEffect, useState, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import DeleteIcon from '@assets/icons/deleteIcon';
import OpenInEditorIcon from '@assets/icons/openInEditorIcon';
import CopyMenuIcon from '@assets/icons/copyMenuIcon';
import EditBrandIcon from '@assets/icons/editBrandIcon';
import { getLabelsFromSection } from '@utils/brand';
import { useLocation } from "react-router-dom";
import EditIcon from '@assets/icons/editIcon';

const Menu:React.FC<IProps> = (props) => {
  const [totalOffSetTop, setTotalOffSetTop]=useState(0);
  const [viewAllPage, setViewAllPage]=useState(false);
    
  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  useEffect(() => {
    if(optionsRef && optionsRef.current){
      let element: any = optionsRef.current
      if (location.pathname==="/brand-library") {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-") && !(element.id as string).startsWith("main-preview-component-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
        if (element)
        {
          while (element && !(element.id as string).startsWith("infinite-scroll-")) {
            element = element.parentElement;
          }
          if (element && (element.id as string).startsWith("infinite-scroll-"))
          {
            setViewAllPage(true);
          }
        }
      }
    }
  }, [optionsRef]);

  /*const handleMetadata = () => {
    props.onActions("METADATA");
    props.setOpen(false);
  }

  const handleReplace = () => {
    props.onActions("REPLACE");
    props.setOpen(false);
  }*/

  const handleDelete = () => {
    props.onActions(props.item, "DELETE");    
    props.setOpen(false);
  }

  let location = useLocation();

  const returnLeftValue = () => {
    var value = props.coordinates.x - 700;

    /*if (location.pathname==="/user-management") {
      value -= 550;
      if (viewAllPage) {
        value += 100;
      }
      if (value + 950 > window.innerWidth) {
        value -= 335;
      }
    }*/
    return value;
  }

  const returnTopValue = () => {
    var value = props.coordinates.y - 180;
    //if (location.pathname==="/user-management") {
      //value = totalOffSetTop;
   // }
    return value;
  }

  const handleEdit=()=>{
    props.onActions(props.item,"EDIT");
    props.setOpen(false);
  }

  
  
  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
    >
      {
        props.open &&
        <S.PopupContainer>
          <S.Title>
            {props.item.user.name}
          </S.Title>
          <S.DescriptionContainer>
            <S.Description>
              {`${props.item.user.email}`}
            </S.Description>
            <S.Description>
              {`User since: ${props.item.createdDate? new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.createdDate??'')):``} `}
            </S.Description>
            <S.Description>
              {`Last Active: ${props.item.lastActive?new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.lastActive??'')):''}`}
            </S.Description>

          </S.DescriptionContainer>
        
            <S.TopOptionsContainer>
              <S.OptionContainer onClick={handleEdit}>
                  <S.OptionIconContainer>
                    <EditIcon />
                  </S.OptionIconContainer>
                  <S.OptionText>
                    {`Edit Name and Permissions`}
                  </S.OptionText>
              </S.OptionContainer>            
            </S.TopOptionsContainer>
            <S.Divider />
          
          <S.BottomOptionsContainer>
            <S.OptionContainer
              onClick={handleDelete}
            >
              <S.OptionIconContainer>
                <DeleteIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Delete User`}
              </S.OptionText>
            </S.OptionContainer>
          </S.BottomOptionsContainer>
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default Menu;